export const networkConfig = {
  25: {
    chainId: `0x${Number(25).toString(16)}`,
    rpcUrls: ["https://cronos-evm-rpc.publicnode.com"],
    chainName: "Cronos",
    blockExplorerUrls: ["https://cronoscan.com"],
    royalAddress: "0xc74EEcF228aa40d5e33BD03a37592F4EDadcB607",
    rewardAddress: "0x550154B9eDDb1dC6871eC1F1214b6f6698A9E94c",
    stakeFeeAddress: "0x548C431DBf2165A770dBF7C57cACae8bFdb820b6",
    marketFeeAddress: "0x5aFD93281F86CBEAa788f384dc53f941B08dd0b6",
    softPayeeAddress: "0x6B7FBb0A0EC0099eED6549eC54d3f79463711DFe",
    softSignerAddress: "0xD6264D05EeBa4Ae3D1F917340C385546d243e798",
    questAddress: "0x6D853a33a5B3CED53f05e04e793F569Cbc268afA",
    defaultClaimFee: 0.25,
  },
  137: {
    chainId: `0x${Number(137).toString(16)}`,
    rpcUrls: ["https://rpc.ankr.com/polygon"],
    chainName: "Polygon",
    blockExplorerUrls: ["https://polygonscan.com"],
    royalAddress: "0xD81d3910263a390a7ffCdCCE5822A558646E0fc4",
    rewardAddress: "0xd20C49330BbE0a123f4c36b636475B41ED33BED8",
    stakeFeeAddress: "0xC6EF9fa383703c15006FdeF1ce124c327706f529",
    marketFeeAddress: "0x2f2CAD0b9E799C312D49126e226627C33Ac13d8d",
    softPayeeAddress: "0x6B7FBb0A0EC0099eED6549eC54d3f79463711DFe",
    softSignerAddress: "0x4ec46a826d074406baD7C937BF17BBd06179eA52",
    questAddress: "0xDBa5bD654334066008c784932bAB305BFbddCe45",
  },
  56: {
    chainId: `0x${Number(56).toString(16)}`,
    rpcUrls: [""],
    chainName: "Binance",
    blockExplorerUrls: [""],
    royalAddress: "0xc20059504647D734d811c3d789Eb0eE335020fA2",
    rewardAddress: "0x0000000000000000000000000000000000000000",
    stakeFeeAddress: "0x0000000000000000000000000000000000000000",
    marketFeeAddress: "0x0000000000000000000000000000000000000000",
    softPayeeAddress: "0x0000000000000000000000000000000000000000",
    softSignerAddress: "0x0000000000000000000000000000000000000000",
    questAddress: "0x095E8Ff2b65111A5Cf1a0E65C734EFd6100de859",
  },
  8453: {
    chainId: `0x${Number(8453).toString(16)}`,
    rpcUrls: [""],
    chainName: "Base",
    blockExplorerUrls: [""],
    royalAddress: "0xc20059504647D734d811c3d789Eb0eE335020fA2",
    rewardAddress: "0x0000000000000000000000000000000000000000",
    stakeFeeAddress: "0x0000000000000000000000000000000000000000",
    marketFeeAddress: "0x0000000000000000000000000000000000000000",
    softPayeeAddress: "0x0000000000000000000000000000000000000000",
    softSignerAddress: "0x0000000000000000000000000000000000000000",
    questAddress: "0x095E8Ff2b65111A5Cf1a0E65C734EFd6100de859",
  },
  81457: {
    chainId: `0x${Number(81457).toString(16)}`,
    rpcUrls: [""],
    chainName: "Blast",
    blockExplorerUrls: [""],
    royalAddress: "0xc20059504647D734d811c3d789Eb0eE335020fA2",
    rewardAddress: "0x0000000000000000000000000000000000000000",
    stakeFeeAddress: "0x0000000000000000000000000000000000000000",
    marketFeeAddress: "0x0000000000000000000000000000000000000000",
    softPayeeAddress: "0x0000000000000000000000000000000000000000",
    softSignerAddress: "0x0000000000000000000000000000000000000000",
    questAddress: "0x095E8Ff2b65111A5Cf1a0E65C734EFd6100de859",
  },
  80002: {
    chainId: `0x${Number(80002).toString(16)}`,
    rpcUrls: ["https://polygon-amoy.drpc.org"],
    chainName: "Amoy Testnet",
    blockExplorerUrls: [""],
    royalAddress: "0x0000000000000000000000000000000000000000",
    rewardAddress: "0x0000000000000000000000000000000000000000",
    stakeFeeAddress: "0x0000000000000000000000000000000000000000",
    marketFeeAddress: "0x0000000000000000000000000000000000000000",
    softPayeeAddress: "0x0000000000000000000000000000000000000000",
    softSignerAddress: "0x0000000000000000000000000000000000000000",
    questAddress: "0x0000000000000000000000000000000000000000",
  },
  84532: {
    chainId: `0x${Number(84532).toString(16)}`,
    rpcUrls: ["https://base-sepolia.blockpi.network/v1/rpc/public"],
    chainName: "Base Sepolia Testnet",
    blockExplorerUrls: [""],
    royalAddress: "0x0000000000000000000000000000000000000000",
    rewardAddress: "0x0000000000000000000000000000000000000000",
    stakeFeeAddress: "0x0000000000000000000000000000000000000000",
    marketFeeAddress: "0x0000000000000000000000000000000000000000",
    softPayeeAddress: "0x0000000000000000000000000000000000000000",
    softSignerAddress: "0x0000000000000000000000000000000000000000",
    questAddress: "0x0000000000000000000000000000000000000000",
  },
  168587773: {
    chainId: `0x${Number(168587773).toString(16)}`,
    rpcUrls: [""],
    chainName: "Blast Sepolia Testnet",
    blockExplorerUrls: [""],
    royalAddress: "0x0000000000000000000000000000000000000000",
    rewardAddress: "0x0000000000000000000000000000000000000000",
    stakeFeeAddress: "0x0000000000000000000000000000000000000000",
    marketFeeAddress: "0x0000000000000000000000000000000000000000",
    softPayeeAddress: "0x0000000000000000000000000000000000000000",
    softSignerAddress: "0x0000000000000000000000000000000000000000",
    questAddress: "0x0000000000000000000000000000000000000000",
  },
};

export const chainOptions = () => {
  let options = [
    { value: "25", label: "Cronos", config: networkConfig[25] },
    { value: "137", label: "Polygon", config: networkConfig[137] },
    { value: "56", label: "Binance", config: networkConfig[56] },
    { value: "8453", label: "Base", config: networkConfig[8453] },
    { value: "81457", label: "Blast", config: networkConfig[81457] },
  ];

  if (process.env.NODE_ENV === "development") {
    options = [
      ...options,
      { value: "80002", label: "Amoy Testnet", config: networkConfig[80002] },
      {
        value: "84532",
        label: "Base Sepolia Testnet",
        config: networkConfig[84532],
      },
      { value: "168587773", label: "Blast Sepolia Testnet", config: networkConfig[168587773] },
    ];
  }
  return options;
};
